import { message } from 'antd';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const createFacility = async (formValues, setNumberError) => {
  try {
    const response = await client.post(
      `/RentPlace/rental_house`,
      {
        id: 0,
        ...formValues,
        totalArea: formValues.totalArea?.replace(/\,/, '.'),
        mopArea: formValues.mopArea?.replace(/\,/, '.'),
        officesAmount: +formValues.officesAmount,
        rentedOfficesAmount: 0,
        broker: {
          id: +formValues.broker,
        },
        manager: {
          id: +formValues.manager,
        },
        description: {
          description: formValues.description,
        },
      },
      { headers: authHeader() }
    );
    if (response.data?.result && response.data.result === 'Error') {
      setNumberError(true);
      return;
    }
    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      // store.dispatch(userActions.logout());
      return;
    }
    message.error('При создании объекта произошла ошибка');
    console.error(error);
  }
};

export default createFacility;
